module.exports = __webpack_public_path__ + "static/media/time-table.3f652985.svg";